// extracted by mini-css-extract-plugin
export default {"addressInfo":"styles_addressInfo__+8bqQ","formItem":"styles_formItem__oqJ5F","formItemCol":"styles_formItemCol__gS5tc"};